import React, { useEffect } from "react";
import { track } from "./analytics";

// Native pre-auth welcome. A single marketing hero (mirrors the web Landing hero)
// that sells the app and routes into signup/login. Deliberately NOT a carousel —
// the post-signup first-run intro owns the swipeable format, so these two onboarding
// moments stay visually distinct.

const BLUE = "#4F7FFA";
const CYAN = "#00BCD4";

export default function Welcome({ onGetStarted }) {
  useEffect(() => { track("screen_viewed", { screen: "welcome" }); }, []);
  return (
    <div style={{ position: "fixed", inset: 0, background: "linear-gradient(160deg, #0f0f1a 0%, #1a1a2e 55%, #1e2a4a 100%)", color: "#fff", display: "flex", flexDirection: "column", paddingTop: "env(safe-area-inset-top, 0px)", paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, paddingTop: 32 }}>
        <div style={{ display: "inline-flex", alignItems: "center", border: `2.5px solid ${CYAN}`, borderRadius: 4, padding: "2px 9px", background: "#000" }}>
          <span style={{ fontSize: 24, fontWeight: 900, color: "#fff", letterSpacing: 2 }}>EL</span>
          <span style={{ fontSize: 24, fontWeight: 900, color: CYAN, letterSpacing: 2 }}>DE</span>
        </div>
        <div style={{ fontSize: 8.5, letterSpacing: 2.5, fontWeight: 700 }}>
          <span style={{ color: "#fff" }}>EL</span><span style={{ color: "#4a5568" }}>IMINATE </span>
          <span style={{ color: CYAN }}>DE</span><span style={{ color: "#4a5568" }}>BT</span>
        </div>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "0 32px", maxWidth: 520, margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
        <div style={{ display: "inline-block", fontSize: 12, fontWeight: 600, color: CYAN, background: "rgba(0,188,212,0.1)", border: "1px solid rgba(0,188,212,0.2)", borderRadius: 20, padding: "5px 14px", marginBottom: 28, letterSpacing: 0.3 }}>✦ Free to start · No credit card</div>
        <h1 style={{ fontSize: 40, fontWeight: 900, lineHeight: 1.08, letterSpacing: -1.5, margin: "0 0 18px" }}>
          Your debt.<br />Every detail.<br /><span style={{ color: BLUE }}>One place.</span>
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.6, color: "#aab4cc", margin: 0, maxWidth: 360 }}>
          Payoff strategies, interest breakdowns, and AI coaching — see exactly when you'll be debt-free.
        </p>
      </div>
      <div style={{ padding: "0 28px 28px", maxWidth: 520, margin: "0 auto", width: "100%", boxSizing: "border-box" }}>
        <button onClick={() => { track("welcome_cta", { action: "signup" }); onGetStarted("signup"); }} style={{ width: "100%", background: BLUE, color: "#fff", border: "none", borderRadius: 12, padding: 16, fontSize: 16, fontWeight: 700, cursor: "pointer", boxShadow: "0 6px 20px rgba(79,127,250,0.45)" }}>Get started free</button>
        <button onClick={() => { track("welcome_cta", { action: "login" }); onGetStarted("login"); }} style={{ width: "100%", background: "none", border: "none", color: "#aab4cc", fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 14, marginTop: 4 }}>I already have an account · Sign in</button>
      </div>
    </div>
  );
}
